import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import firebase from 'firebase/app'
import queryString from 'query-string'
import { connect } from 'react-redux'
import {
  withStyles,
  Typography,
} from '@material-ui/core'

import {
  loading,
  unload,
} from '../actions/app'
import ElytizBlackSrc from '../assets/logo.black.png'


const styles = {
  root: {
    minHeight: '100vh',

    '& h1': {
      fontSize: 40,
      fontFamily: 'Montserrat',

      '& > span': {
        fontFamily: 'Playfair Display',
      }
    },

    '& h2': {
      fontSize: 25,
      marginTop: 20,
      marginBottom: 20,
      color: '#95a5a6',
      fontFamily: 'Montserrat',
      textTransform: 'uppercase',
    },

    '& h3': {
      fontSize: 13,
      marginTop: 10,
      color: '#95a5a6',
      fontFamily: 'Montserrat',
      textTransform: 'uppercase',
    },

    '& h4': {
      fontSize: 13,
      marginTop: 5,
      fontFamily: 'Montserrat',
    },

    '& a[href]': {
      color: 'black',
      textDecoration: 'underline',
    },
  },
  montserrat: {
    fontFamily: 'Montserrat',
  },
  playfair: {
    fontFamily: 'Playfair Display',
  },
  fullWidth: {
    width: '100%',
  },
  row: {
    display: 'table-row',

    '& > *': {
      // padding: 30,
      width: '100%',
      display: 'table-cell',
      verticalAlign: 'middle',
    },
  },
  rowFooter: {
    height: 150,
  },
  logo: {
    height: 50,
  },
  footer: {
    columns: 2,
    padding: 0,
  },
  flex: {
    width: '100%',
    display: 'flex',
    justifyContent: 'stretch',

    '& > *:first-child': {
      flex: 2,
    },

    '& > *:last-child': {
      width: 'auto',
    },
  },
  section: {
    // marginT: '1cm',
    // marginBottom: '1cm',
    // marginLeft: '1cm',
    // marginRight: '4cm',

    // page: 'cover',
    marginLeft: 0,
    marginRight: 0,
    //height: '25mm',
    fontFamily: 'Roboto',
    // breakAfter: 'always',
    // breakBefore: 'always',
    width: 'calc(100vw - 1cm)',
    display: 'table',
    tableLayout: 'fixed',
    alignItems: 'center',
    overflow: 'hidden',
  },
  sectionLarge: {
    height: '100%',
    marginTop: '1.2cm',
    // height: 'calc(100vh - 23cm)',
  },
  mainImageContainer: {
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    height: 'calc(100vh - 6cm)',
  },
  mainImage: {
    height: 'calc(100vh - 5cm)',
  },
  sectionContainer: {
    height: '203mm',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    pageBreakBefore: 'always',
  },
  /*
  section2col: {
    '& > *': {
      padding: 30,
      width: '50%',
      display: 'table-cell',
    },
  },
  */
  informations: {
    textAlign: 'center',
    backgroundColor: '#ecf0f1',
  },
  informationContent: {
    padding: 10,
    height: '100%',
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  imageBackground: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  image: {
    maxWidth: '100%',
    maxHeight: 'calc(100vh - 5cm)',
  },
  center: {
    textAlign: 'center',
    overflow: 'hidden',
  },
  centerImage: {
    overflow: 'hidden',
    display: 'table-cell',
    textAlign: 'center',
    verticalAlign: 'middle',
  }
}



class Book extends Component {
  /* LIFECYCLE */

  state = {
    user: null,
    folios: [],
    coverImage: '',
  }

  componentDidMount() {
    const { id } = this.props.match.params
    const search = queryString.parse(window.location.search)
    const folioIds = (search.folio || '').split(',')

    this.getUser(id, folioIds)
  }


  /* METHODS */

  getUser = async (userId, folioIds) => {
    this.props.loading()

    const db = firebase.firestore()
    const userSnap = await db.collection('users').doc(userId).get()
    const user = userSnap.data()
    const folios = []
    let columns = []

    for (let i = 0; i < folioIds.length; i++) {
      try {
        const folioId = folioIds[i]
        const folioSnap = await db.collection('users').doc(userId).collection('folio').doc(folioId).get()
        const folio = folioSnap.data()

        if (folio.deleted) {
          continue
        }

        /*
        columns.push(folio)

        if (columns.length > 1) {
          folios.push(columns)
          columns = []
        }
        */

        if (folio) {
          folios.push(folio)
        }
      } catch (err) {
        console.error(err)
      }
    }

    /*
    if (columns.length > 0) {
      folios.push(columns)
    }
    */

    return this.setState({
      user,
      ...this.constructFolios(folios),
    }, this.props.unload)
  }

  constructFolios = (folios) => {
    const items = []
    const coverImage = folios[0]
    const restOfFolios = folios.slice(1);

    for (const folio of restOfFolios) {
      const isLandscape = folio.width && folio.height && folio.width > folio.height
      //console.log('--- folio', folio, isLandscape)
      if (!items.length) {
        items.push([{ folio, isLandscape }])
        continue
      }

      const lastItems = items[items.length - 1]
      if (lastItems.length > 1 || lastItems[0].isLandscape || isLandscape) {
        items.push([{ folio, isLandscape }])
      } else {
        lastItems.push({ folio, isLandscape })
      }
    }

    return {
      coverImage,
      folios: items.map((folios) => {
        return folios.map(({ folio }) => folio)
      })
    }
  }


  /* RENDER */

  render() {
    const { classes } = this.props
    const { user, folios, coverImage } = this.state

    if (!user) {
      return <div />
    }

    const Footer = (
      <>
        <div className={classes.center}>
          <img className={classes.logo} src={ElytizBlackSrc} />
        </div>
        <div className={classes.center}>
          <Typography className={classes.montserrat}>Elytiz, 36 Av Hoche 75008 Paris</Typography>
          <Typography className={classes.montserrat}><a href="mailto:info@elytiz.com">info@elytiz.com</a> - <a href="https://www.elytiz.com" target="_blank">www.elytiz.com</a></Typography>
        </div>
      </>
    )

    return (
      <div className={classes.root}>
        <section className={classes.sectionContainer}>
          <div className={classes.fullWidth}>
            <div className={classes.flex}>
              <div className={classes.informations}>

                <div className={classes.informationContent}>
                  <h1>{user.firstname}<br /><span className={classes.playfair}>{(user.lastname || '').substring(0, 1).toUpperCase()}</span></h1>
                  <h2>Portfolio</h2>
                  {user.characteristics && (
                    <>
                      {user.characteristics.height && (
                        <>
                          <h3>Height</h3>
                          <h4>{user.characteristics.height}</h4>
                        </>
                      )}

                      {user.characteristics.bust && (
                        <>
                          <h3>Bust</h3>
                          <h4>{user.characteristics.bust}</h4>
                        </>
                      )}

                      {user.characteristics.waist && (
                        <>
                          <h3>Waist</h3>
                          <h4>{user.characteristics.waist}</h4>
                        </>
                      )}

                      {user.characteristics.hips && (
                        <>
                          <h3>Hips</h3>
                          <h4>{user.characteristics.hips}</h4>
                        </>
                      )}

                      {user.characteristics.shoes && (
                        <>
                          <h3>Shoes</h3>
                          <h4>{user.characteristics.shoes}</h4>
                        </>
                      )}

                      {user.characteristics.hair && (
                        <>
                          <h3>Hair</h3>
                          <h4>{user.characteristics.hair}</h4>
                        </>
                      )}

                      {user.characteristics.eyes && (
                        <>
                          <h3>Eyes</h3>
                          <h4>{user.characteristics.eyes}</h4>
                        </>
                      )}

                      {user.characteristics.ethnicity && (
                        <>
                          <h3>Ethnicity</h3>
                          <h4>{user.characteristics.ethnicity}</h4>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>

              {/* <div className={classes.imageBackground} style={{ backgroundImage: `url(${coverImage.picture.big})` }} /> */}
              <div className={classNames(classes.centerImage, classes.mainImageContainer)}>
                <img className={classNames(classes.image, classes.mainImage)} src={coverImage.picture.big} />
              </div>
            </div>

            <div className={classes.section}>
              <div className={classNames(classes.row, classes.rowFooter)}>
                {Footer}
              </div>
            </div>
          </div>
        </section>


        {folios.map((folio) => {
          const [folio1, folio2] = folio
          const only1col = !folio2

          return (
            <section className={classes.sectionContainer}>
              <div className={classNames(classes.section, classes.sectionLarge, { [classes.section2col]: !only1col })}>
                <div className={classNames(classes.row, classes.rowImage)}>
                  {folio1 && <div className={classes.centerImage}><img className={classes.image} src={folio1.picture.big} /></div>}
                  {folio2 && <div className={classes.centerImage}><img className={classes.image} src={folio2.picture.big} /></div>}
                </div>

                <div className={classNames(classes.row, classes.rowFooter)}>
                  {only1col && <div className={classes.footer}>{Footer}</div>}
                  {!only1col && Footer}
                </div>
              </div>
            </section>
          )
        })}
      </div>
    )
  }
}


Book.propTypes = {
  unload: PropTypes.func,
  loading: PropTypes.func,
  classes: PropTypes.object.isRequired,
}


export default connect(null, {
  unload,
  loading,
})(withStyles(styles)(Book))